import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import InvoiceRow from './InvoiceRow'
import Media from 'react-media'
import styled from '@emotion/styled'
import { css } from '@emotion/core'

const StyledTable = styled('table')`
  width: 100%;
  max-width: 100%;
  border-collapse: collapse;
  margin-top: 16px;
  text-align: left;

  @media only screen and (min-width: 768px) and (max-width: 959px) {
    margin-top: 0;
  }
`

const sharedColStyle = css`
  padding-left: 10px;
  padding-right: 10px;

  :first-child {
    padding-left: 24px;
  }

  :last-child {
    padding-right: 24px;
  }

  @media only screen and (min-width: 768px) {
    :first-child {
      padding-left: 32px;
    }

    :last-child {
      padding-right: 32px;
    }
  }

  @media only screen and (min-width: 960px) {
    :first-child {
      padding-left: 16px;
    }

    :last-child {
      padding-right: 16px;
    }
  }

  &.align--left {
    text-align: left;
  }

  &.align--right {
    text-align: right;
  }
`

const StyledTd = styled('td')`
  font-size: 13px;
  padding-top: ${({ ischild, isEmptyRow }) =>
    ischild || isEmptyRow ? '7px' : '16px '};
  padding-bottom: ${({ ischild }) => (ischild ? '7px' : '16px ')};
  ${sharedColStyle};
`

const StyledTitleTh = styled('th')`
  background-color: ${({ theme }) => theme.gray.highlight};
  font-size: 12px;
  font-style: italic;
  padding: 4px 24px;

  @media only screen and (min-width: 768px) {
    padding-left: 32px;
  }

  @media only screen and (min-width: 960px) {
    padding-left: 16px;
  }
`

const StyledTr = styled('tr')`
  border-bottom: 1px solid ${({ theme }) => theme.gray.light};
  vertical-align: top;
`

const StyledTh = styled('th')`
  font-size: 11px;
  font-style: italic;
  font-weight: 300;
  padding-top: 8px;
  padding-bottom: 8px;
  ${sharedColStyle};
`

const InvoiceTable = props => {
  const getColProps = (titleId = '') => id => {
    const { align = 'left', name } =
      props.columns.find(col => col.id === id) || {}
    return {
      className: `align--${align || 'left'}`,
      headers: `${titleId} ${name}`.trim(),
      key: id,
    }
  }

  const { columns, rows = [], renderRow, className, customerId } = props

  return (
    <Media query='(max-width: 768px)'>
      {isSmallScreen => (
        <StyledTable className={className}>
          <thead>
            <StyledTr>
              {columns.map(
                ({ align = 'left', id, name, style = {}, style2 = {} }) => (
                  <StyledTh
                    key={id}
                    className={`align--${align}`}
                    id={id}
                    scope='col'
                    style={!isSmallScreen ? style : style2}
                  >
                    {name}
                  </StyledTh>
                ),
              )}
            </StyledTr>
          </thead>
          <tbody>
            {rows.length &&
              rows.map((row, i) =>
                renderRow({
                  ...row,
                  key: `row-${i}`,
                  getColProps: getColProps(),
                  customerId,
                }),
              )}
          </tbody>
        </StyledTable>
      )}
    </Media>
  )
}

InvoiceTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  rows: PropTypes.arrayOf(PropTypes.object),
  groups: PropTypes.arrayOf(PropTypes.object),
  renderRow: PropTypes.func.isRequired,
  className: PropTypes.string,
  customerId: PropTypes.number,
}

StyledTd.propTypes = {
  ischild: false,
}
InvoiceRow.propTypes = {
  isParent: false,
  hasCorrections: false,
}
InvoiceTable.Row = InvoiceRow
InvoiceTable.Col = StyledTd

export default InvoiceTable
